import { baseApi } from '../baseApi';

import { SetWorkstationLocationRequest, WorkstationLocation } from './WorkstationLocation';

const slice = baseApi
  .enhanceEndpoints({
    addTagTypes: ['WorkstationLocations'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getWorkstationLocations: builder.query<WorkstationLocation[], void>({
        query: () => ({
          url: `/WorkstationLocations`,
          method: 'GET',
          headers: {
            'x-api-version': '1.0',
          },
        }),
        providesTags: [{ type: 'WorkstationLocations', id: 'LIST' }],
      }),
      setWorkstationLocation: builder.mutation<void, SetWorkstationLocationRequest>({
        query: (body) => ({
          url: `/Workstations/Location`,
          method: 'PUT',
          body,
          headers: {
            'x-api-version': '1.0',
          },
        }),
      }),
    }),
  });

export const { useGetWorkstationLocationsQuery, useSetWorkstationLocationMutation } = slice;
